import type { GlucoseSpecialValue } from "@tandemdiabetes/sugarmate-api-react-client"
import { useDisplayGlucoseValue } from "./useDisplayGlucoseValue"

export function useReadableGlucoseValue(value: number, specialValue?: GlucoseSpecialValue): string {
  const displayGlucoseValue = useDisplayGlucoseValue()
  return displayGlucoseValue(
    value,
    specialValue,
  )
}
